import { FlexColumn, FlexRow, PageTileHeader } from '@make-software/cspr-design';
import AppsCreateStep1 from './apps-create-step-1';
import { PageContainer } from 'app/components/common/common-styles';

export const AppsCreatePage = () => {
  return (
    <FlexColumn>
      <PageTileHeader size={1} scale={'xs'}>
        Create application
      </PageTileHeader>
      <PageContainer>
        <FlexRow justify={'center'} align={'center'}>
          <AppsCreateStep1 />
        </FlexRow>
      </PageContainer>
    </FlexColumn>
  );
};
